// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__Js6UA","legacyBtn":"MutateMid_legacyBtn__5HkZz"};